



































import { Component, Vue } from "vue-property-decorator";
import {
  TitleTemplatePublic,
  RedCapital,
  SelectedCountry
} from "@/configuration";
import { mapState } from "vuex";

@Component({
  computed: mapState(["user", "transaction"]),
  metaInfo: {
    title: "Reserva exitosa",
    titleTemplate: TitleTemplatePublic,
    htmlAttrs: {
      // @ts-ignore
      lang: RedCapital[SelectedCountry].Lang
    }
  },
  data() {
    return {
      RedCapital,
      SelectedCountry
    };
  }
})
export default class SuccessfulReserving extends Vue {}
